import React, {useCallback, useEffect, useState} from "react";
import styled from 'styled-components';
import 'react-dropdown/style.css';
import Button from "../Shared/Button";
import { modalActions,profileActions } from '../../redux/root-action';
import { modals } from '../../utils/constants';
import Input from "../Shared/Input";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import { ProfileBeaconError } from "components/Shared/ProfileBeaconComponents";
import useLocalizePhrase from "../../utils/useLocalizePhrase";

import {
    getPersonalInformationData,
    getEmailAddress,
    getIsEditMobileMode,
    getMobileNumber,
    getUpdatedMobileNumber,
    isMobileNumberValid,
    getIsEditEmailMode,
    getEmailDeliveryStatus,
    getUpdatedEmailAddress,
    getIsEmailAddressValid,
    getSelectedPlan,
    getIsEmailAddressError,
    getIsPlanNonQualified,
    getTracPlan,
    getShowSignUpForTextAlertsButton,
    getIsUpdatePhoneNumberLoaded, getIsSavePhoneNumberLoaded
} from "../../redux/profile/selectors";
import {
    savePhoneNumber,
    updatePhoneNumber,
    setIsEditMobileMode,
    setMobileNumberValid,
    setUpdatedMobileNumber,
    setIsEditEmailMode,
    updateEmailAddress,
    setEmailAddressValid,
    setUpdatedEmailAddress,
    setIsEmailAddressError,
    setIsActivationCodeLoaded,
    setIsSignUpForTextAlerts,
    setIsUpdatePhoneNumberLoaded,
    setIsSavePhoneNumberLoaded, setNavigateToPreferencesAndSubscription
} from "../../redux/profile/slice";
import {toTitleCase} from "../../utils/helpers";
import Popover from "../Shared/Popover";
import {isInternal} from "../../utils/api";
import type { CTAVariant } from "@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant";
import { CTAVariants } from "@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant";
import { ProfileBeaconButton } from "components/Shared/ProfileBeaconComponents";


const StyledProfileInfo = styled.div`
  padding: 32px 40px;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const HeaderText = styled.div`
  color: #3b4b59;
  border-bottom: 1px solid #bec3c8;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledContainer = styled.div`
  margin-top: 16px;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  color: #3b4b59;
  :last-child {
    padding-bottom: 0;
  }
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    font-size: 16px;
  }
`;

const StyledErrorContainer = styled.div`  display: flex;    justify-content: right;`;const StyledError = styled(ProfileBeaconError)`  @media (max-width: 1024px) {    width: 170px;      }    `;

const StyledTooltipContainer = styled.div`
  display: flex ;
  justify-content: space-between;
  flex-direction:row;
  align-items:center
`;

const StyledTitle = styled.div.attrs((props: {isEmailAddressError: boolean}) => props)`
  font-family: "Nimbus Sans Novus Regular";
  padding-top: ${(props) => props.isEmailAddressError && "0px"};
  @media (max-width: 1024px){
    padding-top: 0;
  }
`;

const StyledAddressValue = styled.div`
  font-family: "Nimbus Sans Novus Bold";
  width: 268px;
  text-align: right;
`;

const StyledValue = styled.div.attrs((props: {isEmailAddress: boolean}) => props)`
  font-family: "Nimbus Sans Novus Bold" !important;
  word-break: ${(props) => props.isEmailAddress && "break-word"};
`;

const StyledValueContainer = styled.div`
  font-family: "Nimbus Sans Novus Bold";
  
  display: flex;
  align-items: center;
  @media(max-width: 1024px){
    justify-content: end;
    width: 100%;
  }

`;

const StyledLinkContainer = styled.div`
  font-family: "Nimbus Sans Novus Regular";
  font-weight: var(--beacon-font-weight-bold);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
`;
const StyledDisclaimerContainer = styled.div`
  padding: 16px 24px;
  border-radius: 4px;
  border: solid 1px #dd3636;
  background-color: rgba(221, 54, 54, 0.08);
  font-family: "Nimbus Sans Novus Regular";
  letter-spacing: 0.02px;
  @media (max-width: 768px) {
    padding: 24px;
  }
  @media (max-width: 640px) {
    padding: 24px 16px;
  }
`;

const StyledDisclaimerHeader = styled.div`
  font-size: 18px;
  font-weight: var(--beacon-font-weight-bold);
  text-align: left;
  line-height: 1.2;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const StyledDisclaimerContent = styled.div`
  font-size: 18px;
  margin-top: 4px;
  line-height: 1.33;
  @media (max-width: 768px) {
    font-size: 16px;
    margin-top: 8px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
    margin-top: 8px;
  }
`;

const StyledEmailContainer = styled.div.attrs((props: {isEmailValue: boolean}) => props)`
  display: flex;
  align-items: center;
 
  flex-wrap: wrap;
  
  
  justify-content: flex-end;
  @media(max-width: 1024px){
    justify-content: end;
    width: 100%;
    padding-top: ${(props) => props.isEmailValue && "12px"};
  }
 
  
`;
const StyledEmailContainerInput = styled.div.attrs((props: {isEmailValue: boolean}) => props)`
  display: flex;
  align-items: center;
 gap:12px;
  flex-wrap: wrap;
  #emailAddress{
  padding-left:0px;
  }
  
  justify-content: flex-end;
  @media(max-width: 1024px){
    justify-content: end;
    width: 100%;
    padding-top: ${(props) => props.isEmailValue && "12px"};
  }
 
  
`;


const StyledPhoneNumberContainer = styled.div `
  display: flex;
  width: 220px;
  align-items: center;
  justify-content: end;
  @media (max-width: 1024px){
    width: 100%;
  }
  #mobileNumber{
  padding-left:0px}
`;

const StyledInputFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  color: #3b4b59;
  flex-wrap: wrap;
  @media (max-width: 1024px){
    font-size: 16px;
    align-items: center;
  }
`;

const StyledPhoneButton = styled.div`
margin-left: 12px;
  @media (max-width: 1024px){
    margin-left: 0;
  }
  `;

const StyledButton = styled.div.attrs((props: {isEmailAddressError: boolean}) => props)`
  padding-top: ${(props) => props.isEmailAddressError && "0px"};
  @media (max-width: 640px) {
    width: 42px;
  }
  @media (max-width: 1024px) {
    width: 38px;
    padding-top: ${(props) => props.isEmailAddressError && "0px"};
  }
`;

export const PersonalInformationCard = () => {
    const dispatch = UseAppDispatch();
    const saveButtonTitle = useLocalizePhrase('Save');
    const editButtonTitle = useLocalizePhrase('Edit');
    const personalInformationTitle = useLocalizePhrase('Personal Information');
    const nameTitle = useLocalizePhrase('Name');
    const dateOfBirthTitle = useLocalizePhrase('Date of Birth');
    const enterAValidEmailAddressTitle = useLocalizePhrase('Enter a valid email address');
    const emailAddressTitle = useLocalizePhrase('Email Address');
    const updateYourEmailAddressTitle = useLocalizePhrase('Update your email address');
    const addMobileNumberTitle = useLocalizePhrase('Add Mobile Number');
    const addressTitle = useLocalizePhrase('Address');
    const cityTitle = useLocalizePhrase('City');
    const stateTitle = useLocalizePhrase('State');
    const zipCodeTitle = useLocalizePhrase('Zip Code');
    const mobileNumberTitle = useLocalizePhrase('Mobile Number');
    const toSignupForTextAlertsTitle = useLocalizePhrase('To sign up for text alerts, click "Edit" in the Preferences section below. Adding your mobile number does not automatically sign you up for text alerts.');
    const getPersonalInfoData = UseAppSelector(getPersonalInformationData);
    const fullName = getPersonalInfoData?.fullName;
    const dateOfBirth = new Date(getPersonalInfoData?.birthDate);
    const postalAddress = getPersonalInfoData?.postalAddress;
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const isPlanNonQualified = UseAppSelector(getIsPlanNonQualified);
    const isTracPlan = UseAppSelector(getTracPlan);
    const isOmniPlan = !isPlanNonQualified && !isTracPlan;

    const mobileNumber = UseAppSelector(getMobileNumber);
    const updatedMobileNumber = UseAppSelector(getUpdatedMobileNumber);
    const isEditMobileMode = UseAppSelector(getIsEditMobileMode);
    const mobileNumberValid = UseAppSelector(isMobileNumberValid);
    const showSignUpForTextAlertsButton = UseAppSelector(getShowSignUpForTextAlertsButton);
    const isUpdatePhoneNumberLoaded = UseAppSelector(getIsUpdatePhoneNumberLoaded);
    const isSavePhoneNumberLoaded = UseAppSelector(getIsSavePhoneNumberLoaded);
    const [isSaveMobileNumber,setIsSaveMobileNumber] = useState(false);

    const emailAddress = UseAppSelector(getEmailAddress);
    const isEmailUndeliverable = UseAppSelector(getEmailDeliveryStatus);
    const updatedEmailAddress = UseAppSelector(getUpdatedEmailAddress);
    const isEditEmailMode= UseAppSelector(getIsEditEmailMode);
    const emailAddressValid = UseAppSelector(getIsEmailAddressValid);
    const isEmailAddressError = UseAppSelector(getIsEmailAddressError);
    const emailRegex = /^[a-zA-Z0-9.-_]+@[a-zA-Z]+\.[a-zA-Z]{3,4}$/;
    const [isPhoneNumberChanged, setIsPhoneNumberChanged] = useState(false);

    const handleEditMobile = () => {
        dispatch(setIsEditMobileMode(true));
    }
    const handleEditEmail = () => {
        dispatch(setIsEditEmailMode(true))
    }

    const handleEmailAddressChange = (event: any) => {
        dispatch(setUpdatedEmailAddress(event.target.value));
        if (emailRegex.test(event.target.value)) {
            dispatch(setEmailAddressValid(true))
        }
        else
            dispatch(setEmailAddressValid(false))
    }

    const handleEmailValidation = (event: any) => {
        if (event.target.value !== "" && !emailRegex.test(event.target.value))
            dispatch(setIsEmailAddressError(true))
        else
            dispatch(setIsEmailAddressError(false))
    }
   ;

    const handleMobileNumberChange = (event: any) => {
      let value=event.target.value;
      value=value.replace(/\D/g, "");
      value=value.slice(0,10);
      if (value.length>6){
        value=value.replace(/(\d{3})(\d{3})(\d{1,4})/,"$1-$2-$3");
      }else if (value.length>3){
        value=value.replace(/(\d{3})(\d{1,3})/,"$1-$2");
      }
      
      event.target.value=value;
        dispatch(setUpdatedMobileNumber(value));
        if(event.target.value.length === 12) {
            dispatch(profileActions.setMobileNumberValid(true))
        } else {
            dispatch(profileActions.setMobileNumberValid(false))
        }

     

    }

    const showSignUpAuthenticatedModal = useCallback(() => {
        dispatch(setNavigateToPreferencesAndSubscription(true));
        dispatch(modalActions.showModal(modals.SIGN_UP_AUTHENTICATED_MODAL));
    }, [dispatch]);

    const saveMobileNumber = useCallback((updatedMobileNumber) => {
        if(mobileNumber !== updatedMobileNumber)
            setIsPhoneNumberChanged(true);
        else
            setIsPhoneNumberChanged(false);
        if(mobileNumber){
            dispatch(updatePhoneNumber({mobileNumber:updatedMobileNumber, planNumber}));
        } else {
            dispatch(savePhoneNumber({mobileNumber:updatedMobileNumber, planNumber}));
        }
        setIsSaveMobileNumber(!isSaveMobileNumber);
    },[dispatch,mobileNumber]);

    useEffect(() => {
        if (isUpdatePhoneNumberLoaded || isSavePhoneNumberLoaded) {
            dispatch(setIsUpdatePhoneNumberLoaded(false));
            dispatch(setIsSavePhoneNumberLoaded(false));
            if(isPhoneNumberChanged) {
                showSignUpForTextAlertsButton && showSignUpAuthenticatedModal();
            }

            !showSignUpForTextAlertsButton && showSignUpModal();
        }
    },[isSaveMobileNumber, isUpdatePhoneNumberLoaded, isSavePhoneNumberLoaded]);


    const showSignUpModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.SIGN_UP_MODAL));
    },[dispatch]);

    const saveEmailAddress =  useCallback((updatedEmailAddress) => {
        dispatch(updateEmailAddress({emailAddress: updatedEmailAddress, planNumber}));
    }, [dispatch, emailAddress]);

        const closeThisModal = () => {
            console.log("hi");
            dispatch(modalActions.closeModal());
        }

    return (
        <StyledProfileInfo>
            <HeaderText >
                {personalInformationTitle}
                <Popover
                    id = "personal-Information"
                    label="Personal Info Icon"
                    onClose={closeThisModal}
                    popoverTitle=" "
                    popoverContent = "To update name, date of birth, or address, current employees must contact their Human Resources Department. Former employees can request a change by contacting T. Rowe Price directly. Note: These rules vary by plan and may not be applicable to all situations."/>
            </HeaderText>

                <StyledContainer>
                    <StyledTitleContainer className="blocked_data .b-font-weight-bold">
                        <StyledTitle >{nameTitle}</StyledTitle>
                        <StyledValue >{fullName}</StyledValue>
                    </StyledTitleContainer>
                    <StyledTitleContainer className="blocked_data">
                        <StyledTitle >{dateOfBirthTitle}</StyledTitle>
                        <StyledValue >{dateOfBirth?dateOfBirth.toLocaleDateString(undefined, { timeZone: 'UTC'}):"" }</StyledValue>
                    </StyledTitleContainer>
                    {isEmailAddressError && <StyledErrorContainer><StyledError slot='error'>{enterAValidEmailAddressTitle}</StyledError></StyledErrorContainer>}
                        <StyledInputFieldContainer className="blocked_data">
                        <StyledTitle isEmailAddressError={isEmailAddressError}>{emailAddressTitle}</StyledTitle>
                        { ( emailAddress && emailAddress.trim().length !== 0 && !isEditEmailMode) ?
                        <StyledEmailContainer isEmailValue={true}>
                        <StyledValue isEmailAddress={true}>{emailAddress}</StyledValue>
                        <StyledLinkContainer>
                            <Button key={editButtonTitle} variant="tertiary" isIcon={true} buttonTitle={editButtonTitle} disabled={isInternal()} onBeaconClick={() => !isInternal() && handleEditEmail()}>{editButtonTitle}</Button>
                        </StyledLinkContainer>
                    </StyledEmailContainer> :
                            isEditEmailMode ?
                                <StyledEmailContainerInput>
                                 
                                  
                                    <Input name="emailAddress" id="emailAddress" placeholder="example@gmail.com"
                                           pattern={emailRegex} type="email" value={updatedEmailAddress}
                                           onInput={handleEmailAddressChange}
                                           onBlur={handleEmailValidation}
                                           maxlength={80}
                                           errorsMap={{
                                               noMatchPattern: "Enter a valid email address",
                                           }}
                                           isPlanInfoError={isEmailAddressError}
                                           isPersonalInfo={true}
                                    />
                                    <StyledButton isEmailAddressError={isEmailAddressError}>
                                        <Button key={editButtonTitle} variant="tertiary" buttonTitle={saveButtonTitle}
                                                disabled={!emailAddressValid || isInternal()}
                                                onBeaconClick={() => saveEmailAddress(updatedEmailAddress)}/>
                                    </StyledButton>
                                    
                                    </StyledEmailContainerInput>
                                : <StyledValueContainer>
                                    <Button variant={CTAVariants.Tertiary}
                                    
                                    buttonTitle="Add Email Address"
                                            onBeaconClick={() => handleEditEmail()}/>
                                </StyledValueContainer>
                        }

                    </StyledInputFieldContainer>

                    { isEmailUndeliverable &&
                    <StyledDisclaimerContainer>
                        <StyledDisclaimerHeader>
                            {updateYourEmailAddressTitle}
                        </StyledDisclaimerHeader>
                            <StyledDisclaimerContent>
                                We have not been able to deliver a message to your email address on file. Please update your email address.
                            </StyledDisclaimerContent>
                    </StyledDisclaimerContainer>
                    }

                <StyledInputFieldContainer>
                    <StyledTooltipContainer>
                        <StyledTitle >{mobileNumberTitle}</StyledTitle>
                        { isOmniPlan &&
                            <Popover
                                id = "mobile-number-popover"
                                label="Mobile Number Info Icon"
                                onClose={closeThisModal}
                                popoverTitle=" "
                                popoverContent = {toSignupForTextAlertsTitle}/>
                        }
                    </StyledTooltipContainer>
                    { (mobileNumber && !isEditMobileMode) ?
                    <StyledValueContainer>
                        <StyledValue >{mobileNumber}</StyledValue>
                        <StyledLinkContainer>
                            <Button
                                variant="tertiary"
                                isIcon={true}
                                onBeaconClick={() => !isInternal() && handleEditMobile()}
                                buttonTitle={editButtonTitle}
                                disabled={isInternal()}/>
                        </StyledLinkContainer>
                    </StyledValueContainer> :
                        isEditMobileMode ?
                            <StyledPhoneNumberContainer>
                                <Input
                                    type="text"
                                    id="mobileNumber"
                                    value={updatedMobileNumber}
                                    format="000-000-0000"
                                    formatType="pattern"
                                    placeholder="123-456-7890"
                                    onInput={handleMobileNumberChange}
                                    isPersonalInfo={true}
                                />
                                <StyledPhoneButton>
                                    <Button
                                    variant="tertiary"
                                    buttonTitle={saveButtonTitle}
                                    disabled={!mobileNumberValid || isInternal()}
                                    onBeaconClick={()=>saveMobileNumber(updatedMobileNumber)}/>
                                </StyledPhoneButton>
                            </StyledPhoneNumberContainer> :
                            <StyledValueContainer>
                                <Button
                                    variant="tertiary"
                                    buttonTitle={addMobileNumberTitle}
                                    onBeaconClick={() => handleEditMobile()}/>
                            </StyledValueContainer>
                    }
                </StyledInputFieldContainer>

                     <StyledTitleContainer className="blocked_data">
                        <StyledTitle >{addressTitle}</StyledTitle>
                        <StyledAddressValue >{toTitleCase(postalAddress?.addressLine1)}
                            <StyledAddressValue >{toTitleCase(postalAddress?.addressLine2)}</StyledAddressValue>
                        </StyledAddressValue>

                     </StyledTitleContainer>
                    <StyledTitleContainer className="blocked_data">
                        <StyledTitle >{cityTitle}</StyledTitle>
                        <StyledValue >{toTitleCase(postalAddress?.city)}</StyledValue>
                    </StyledTitleContainer>
                    <StyledTitleContainer className="blocked_data">
                        <StyledTitle >{stateTitle}</StyledTitle>
                        <StyledValue >{postalAddress?.state}</StyledValue>
                    </StyledTitleContainer>
                    <StyledTitleContainer className="blocked_data">
                        <StyledTitle >{zipCodeTitle}</StyledTitle>
                        <StyledValue >{postalAddress?.zipCode9}</StyledValue>

                    </StyledTitleContainer>
                </StyledContainer>

            </StyledProfileInfo>

    );
};
